import "./AnimatedBackground.css";

export default function AnimatedBackground() {
  return (
    <div className="bg-wrapper">
      <div className="wave w1"></div>
      <div className="wave w2"></div>
      <div className="wave w3"></div>
      <div className="glow-orb orb1"></div>
      <div className="glow-orb orb2"></div>
    </div>
  );
}